import styles from "./hexagoncomponent.module.css";
import logo from "./../../assets/logo.png";
import ImageWithFallback from '../ImageWithFallback';

export default function HexagonComponent() {
  return (
    <div className={styles.hexagonContainer}>
      <div className={styles.hex1}>
        <div className={styles.hex2}>
          <ImageWithFallback loading="lazy" className={styles.logo} src={logo} alt="logo" />
        </div>
      </div>
    </div>
  );
}
